import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import style from "./LoginStyle";
import { useAuth } from "../../Context/AuthContext"; // Importa o hook

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { login } = useAuth(); 
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(""); // Limpa erros anteriores
    if (username && password) {
      const success = await login(username, password);
      if (success) {
        navigate("/dashboard"); // Redireciona para o dashboard em caso de sucesso
      } else {
        setError("Usuário ou senha inválidos.");
      }
    } else {
      setError("Por favor, preencha todos os campos.");
    }
  };

  return (
    <div style={style.container}>
      <div style={style.loginBox}>
        <div style={style.header}>
          <img src="/imgs/logo.png" alt="Logo" style={style.logo} />
          <h1 style={style.title}>Bem-vindo de volta!</h1>
          <p style={style.subtitle}>
            Acesse sua conta para gerenciar suas plataformas.
          </p>
        </div>
        <form onSubmit={handleLogin} style={style.form}>
          <div style={style.inputGroup}>
            <label htmlFor="username" style={style.label}>
              Usuário
            </label>
            <input
              type="text"
              id="username"
              style={style.input}
              placeholder="Ex: devmello"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div style={style.inputGroup}>
            <label htmlFor="password" style={style.label}>
              Senha
            </label>
            <input
              type="password"
              id="password"
              style={style.input}
              placeholder="••••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && (
            <p style={{ color: "#F87171", textAlign: "center" }}>{error}</p>
          )}
          <a href="#" style={style.forgotPassword}>
            Esqueceu a senha?
          </a>
          <button type="submit" style={style.loginButton}>
            Entrar
          </button>
        </form>
      </div>
    </div>
  );
}
